// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2ubs5","filesListContainer":"PosDisputesFiles_filesListContainer__2hcyq","filesButton":"PosDisputesFiles_filesButton__MiHUs"};